<style scoped>
.precos {
  margin-top: 0;
  font-size: 1.8rem;
  font-weight: bold;
  color: #365db5;
  text-align: left;
}

.parcelado {
  display: block;
  font-size: 1.7rem;
  color: #900;
  font-weight: 500;
}

.badge {
  background: #2e89ee;
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.85rem;
  width: 50%;
}

.btn-simular {
  color: #fff;
  background-color: #d9534f;
  border-color: #d9534f;
  border-radius: 14px;
  width: 80%;
}

.btn-simular:hover {
  background-color: #e46965;
  border-color: #e46965;
}

.text-flag {
  padding-top: 20px;
}

.table-head {
  background-color: rgb(0, 114, 167);
  color: rgb(231, 231, 231);
}

.table .table-striped .col-md-8 {
  border: rgb(0, 114, 167) 2px solid;
}

.col-md-6 .text-center {
  border: rgb(0, 114, 167) 2px solid;
}

#features .nav-tabs {
  display: inline-block;
  margin-top: 20px;
}

.tab-content-item-card {
  max-height: 350px;
  overflow-y: scroll;
  border: rgb(231, 231, 231) 2px solid;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #fff;
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(0, 114, 167);
  border-radius: 8px;
  border: #fff 1.5px solid;
}

.nav-tabs {
  padding-top: 10px;
  border-bottom: 1px solid #fff;
  display: inline-block;
}

.nav-tabs > li {
  float: left;
  margin-bottom: -1px;
  cursor: pointer;
}

.nav > li {
  position: relative;
  display: block;
}

* {
  margin: 0 auto;
}

.nav-tabs > li.active a {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.26);
  border-bottom: 4px solid rgb(0, 114, 167);
  background: #f8f8f8;
}

#features .nav-tabs > li.active > a {
  color: rgb(0, 114, 167);
}

#features .nav-tabs > li > a {
  font-size: 25px;
}

#features .nav-tabs > li > a {
  color: #555;
  margin-right: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.26);
  background-color: #fff;
  border-right: 1px solid #e0e0e0;
  border-radius: 0px;
  border-bottom: 1px solid #ffffff;
  width: 100px;
  padding: 0;
  height: 90px;
  line-height: 90px;
  font-size: 32px;
}

.nav > li > a {
  position: relative;
  display: block;
  padding: 8px 9px;
  border-radius: 0px 0px 0px 0px;
  background: #f3f3f3;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

#features .nav-tabs > li > a:hover {
  border-color: transparent;
  border-right: 1px solid #e0e0e0;
}

.nav li:first-child a {
  border-top-left-radius: 20px;
}

.nav li:last-child a {
  border-top-right-radius: 20px;
}

.image-bandeira {
  width: 26px;
  height: 18px;
}

.image-bandeira img {
  width: 55px;
  height: 36px;
}

@media (max-width: 625px) {
  .image-bandeira {
    width: 20px;
    height: 10px;
  }

  .image-bandeira img {
    width: 52px;
    height: 34px;
  }

  .nav > li > a {
    padding: 7px 8px;
  }
}

@media (max-width: 500px) {
  .image-bandeira {
    width: 15px;
    height: 9px;
  }

  .image-bandeira img {
    width: 48px;
    height: 28px;
  }

  .nav > li > a {
    padding: 5px 7px;
  }
}

@media (max-width: 450px) {
  .image-bandeira {
    width: 10px;
    height: 6px;
  }

  .image-bandeira img {
    width: 45px;
    height: 25px;
  }

  .nav > li > a {
    padding: 6px 7px;
  }
}

@media (max-width: 400px) {
  .image-bandeira {
    width: 10px;
    height: 6px;
  }

  .image-bandeira img {
    width: 40px;
    height: 21px;
  }

  .nav > li > a {
    padding: 5px 6px;
  }
}

@media (max-width: 360px) {
  .image-bandeira {
    width: 10px;
    height: 6px;
  }

  .image-bandeira img {
    width: 35px;
    height: 17px;
  }

  .nav > li > a {
    padding: 4px 5px;
  }
}
</style>

<template>
  <div class="container">
    <Breadcrumb :pages="breadcrumbPages" v-if="productError == false" />
    <div v-if="productError" class="row">
      <div class="col-md-12">
        <div class="page-error">
          <h2>Produto {{ this.$route.params.code }} indisponível</h2>
          <a :href="`${$SiteUrl}`">Voltar à página inicial</a>
        </div>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-md-12 main-content-area">
        <Loader v-if="loadingProductDetails" />

        <div v-else class="wrap-product-detail">
          <div class="detail-media">
            <div class="product-gallery">
              <ul class="slides">
                <li v-for="(image, index) in productImages" :key="index" :data-thumb="image.ArqUrlHires" :data-thumb-alt="image.ArqDescricao">
                  <img
                    async
                    style="margin-left: 135px; margin-right: 135px; max-width: 57%; margin-top: 27px"
                    :src="image.ArqUrlHires"
                    :alt="image.ArqDescricao"
                    :title="image.ArqDescricao"
                  />
                </li>
              </ul>
            </div>
            <div v-for="(selo, index) in productSelo" :key="index">
              <a style="cursor: pointer" target="_blank" :href="selo.URL">
                <img async :srcset="selo.Selo" :src="selo.Selo" :alt="selo.Campanha" :title="selo.Campanha" class="img-slide" />
              </a>
            </div>
          </div>
          <div>
            <div class="detail-info product">
              <p class="product-code"><span>Código:</span> {{ `${productDetails.PRD_CODIGO}-${productDetails.PRD_CODIGODV}` }}</p>
              <h1 class="product-name" style="color: #0a0891 !important; font-weight: bold !important;">
                {{
                  `${productDetails.PSG_DESCRICAO}
                (${productDetails.PRD_CODIGO}-${productDetails.PRD_CODIGODV})`
                }}
              </h1>
              <h2 class="product-description">
                {{ ` ${productDetails.PRD_DESCRICAOINT.length > 0 ? productDetails.PRD_DESCRICAOINT : productDetails.PRD_DESCRICAO}` }}
              </h2>

              <div v-if="isLogged" style="margin-bottom: 10px; padding: 10px; margin-bottom: -10px;">
                <p v-if="productDetails.Saldo == 'DISPONÍVEL' && this.productDetails.Preco > 0" class="product-available">
                  <i class="fa fa-check"></i> Disponível em estoque
                </p>
                <p v-else-if="productDetails.Saldo == 'INDISPONÍVEL'" class="product-unavaiable">: Indisponível em estoque</p>
                <p v-else-if="productDetails.Saldo == 'SOB ENCOMENDA' && this.productDetails.Preco > 0" class="product-unavaiable">: Sob Encomenda</p>
                <p
                  v-else-if="
                    (productDetails.Saldo == 'SOB ENCOMENDA' && this.productDetails.Preco == 0) ||
                    (productDetails.Saldo == 'DISPONÍVEL' && this.productDetails.Preco == 0)
                  "
                  class="product-unavaiable"
                >
                  Indisponível em estoque
                </p>
                <p v-else-if="productDetails.Saldo.split(';')[1]" class="product-unavaiable">
                  : Disponível em {{ productDetails.Saldo.split(';')[0] }} <br />
                  (<strong>
                    {{
                      productDetails.Saldo.split(';')[1].charAt(0).toUpperCase() + productDetails.Saldo.split(';')[1].slice(1).toLowerCase()
                    }} </strong
                  >)
                </p>
                <p v-else class="product-unavaiable">: Disponível em {{ productDetails.Saldo.split(';')[0] }}</p>
              </div>
              <!-- PREÇOS -->
              <!-- Preço DE-->

              <del v-if="promotionalPrice && isLogged && promotionalPrice != precoAVista" class="wrap-price">
                <p
                  class="product-price"
                  style="
                    text-decoration: line-through;
                    font-size: 15px !important;
                    font-weight: bold !important;
                    margin-bottom: 5px !important;
                    color: #888888;
                    line-height: 20px;
                  "
                >
                  De: {{ promotionalPrice }}
                </p>
              </del>

              <!-- Preço à vista com desconto + Preço a prazo com imagem -->
              <div class="wrap-price" style="margin-bottom: 10px; text-align: left; min-width: 220px">
                <!-- À vista com desconto -->
                <div v-if="precoAVista && !precoAvistaIgualPrecoAPrazo">
                  <div class="badge">
                    <svg width="18" height="18" fill="white" viewBox="0 0 24 24">
                      <path d="M2 12L12 2H22V12L12 22L2 12Z" fill="white" />
                      <circle cx="17" cy="7" r="1.5" fill="#2e89ee" />
                    </svg>
                    DESCONTO EXCLUSIVO À VISTA
                  </div>
                  <div class="precos">{{ precoAVista }}</div>
                </div>
                <!-- Valor a prazo com imagem à direita -->
                <div v-if="preco" class="row" style="align-items: center; margin-top: 20px">
                  <div class="col-md-6" style="padding: 0 !important; width: 13%">
                    <img src="/assets/images/IconeDestrave.jpg" alt="Destrave seu negócio" style="max-width: 75px; height: auto" />
                  </div>
                  <div class="col-md-6">
                    <div style="font-size: 13px; color: #900; margin-top: -4px">Ou em até 9x Semanais</div>
                    <div class="parcelado">{{ preco }}</div>
                  </div>
                </div>
              </div>

              <PaymentOptionsModal :preco="productDetails.PrecoAVista" :codigoProduto="productDetails.PRD_CODIGO" :mostrarBotaoVerMais="true" />

              <!-- Preço a prazo com ST -->
              <div v-if="precoComSt != preco" class="wrap-price small-price">
                <span class="product-price re-value">{{ precoComSt }} à prazo com ST</span>
              </div>

              <div v-if="productDetails.IsGerador && productDetails.PrecoEUP" :style="financiamentoStyles">
                <!-- <img v-if="showSimulationButton && showSimulationSantander"
                                src="/assets/images/santander-selo2.png" style="cursor: pointer;" @click="mostrarModal"
                                class="img-fluid" alt="SIMULAR CRÉDITO SANTANDER" /> -->
                <!-- <simulation-santander :precoEUP="productDetails.PrecoEUP"
                                        origem="P"
                                        :prd_codigo="productDetails.PRD_CODIGO"
                                        :isLogged="isLogged" /> -->

                <img
                  v-if="showSimulationButton && showSimulationSolAgora"
                  src="/assets/images/sol-agora-selo.png?v=1"
                  style="cursor: pointer"
                  @click="mostrarModalSolAgora"
                  class="img-fluid"
                  alt="SIMULAR CRÉDITO SOL AGORA"
                />

                <simulation-solagora :precoEUP="productDetails.PrecoEUP" />
              </div>

              <!-- Preço de consumo -->
              <div v-if="precoComSt == preco && isLogged && this.productDetails.PrecoSTSimulacao > 0" class="wrap-price">
                <span style="background: orange" class="product-suggested-price tag" title="Valor apenas para simulação, consulte seu contador"
                  >Valor para simulação</span
                >
                <span class="product-price" title="Valor apenas para simulação, consulte seu contador">
                  {{ precoSTSimulacao }}
                </span>
              </div>

              <!-- FIM PREÇOS -->

              
              <div v-if="isLogged && productDetails.Saldo != 'INDISPONÍVEL' && this.productDetails.Preco > 0">
                <div class="row" style="margin: 20px auto 10px auto">
                  <div class="form-group">
                    <label class="control-label" for="valor-repasse">Valor do Repasse (Máximo sugerido: {{ formatCurrency(maxPrecoSugerido) }})</label
                    ><br />
                    <input
                      class="form-control cart-price-input"
                      id="valor-repasse"
                      name="valor-repasse"
                      style="margin: auto; text-align: left; float: left; width: 50%"
                      placeholder="Valor do Repasse"
                      v-model="valorRepasseFormatado"
                      v-money="moneyConfig"
                      v-bind="moneyConfig"
                      v-on:focusout="openCotacaoFrete(true)"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label class="control-label" for="txtCEP">Consultar frete e prazo de entrega</label><br />
                    <div style="display: flex">
                      <input
                        id="txtCEP"
                        name="txtCEP"
                        type="text"
                        placeholder="Inserir CEP"
                        class="form-control input-md"
                        v-model="frete.cep"
                        v-mask="'#####-###'"
                      />
                      <button v-on:click="openCotacaoFrete()" :disabled="frete.cep.length !== 9" class="btn btn-primary">Buscar</button>
                    </div>
                    <a
                      id="linkEsqueciCep"
                      target="_blank"
                      href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                      class="sc-85bbe06c-7 gXnBba"
                      >Não lembro meu CEP</a
                    >
                  </div>
                </div>

                <ProductShippingDetails
                  :cep="frete.cep"
                  :totalProduto="frete.totalProduto"
                  :codigoProduto="frete.codigoProduto.toString()"
                  :qtdeProduto="frete.qtdeProduto"
                  :codigoCliente="frete.codigoCliente"
                  :peso="frete.peso"
                  :personalizacao="false"
                  :valorRepasse="frete.valorRepasse"
                  :isGerador="frete.isGerador"
                  :isBateria="frete.isBateria"
                  ref="modalFrete"
                >
                </ProductShippingDetails>
              </div>
              <span v-if="produtoSemDesconto" class="tag tag-green">Preço Promocional</span>

              <div v-if="hasTimer && isLogged" class="wrap-countdown produto-countdown" data-expire="">
                <div class="col-md-3"><i class="fa fa-clock-o countdown-icon text-center" /></div>
                <div class="col-md-9">
                  <div class="countdown-label">Oferta expira em:</div>
                  <div id="timer-produto"></div>
                </div>
              </div>

              <div class="campaign-imgs">
                <span v-for="(campanha, index) in productCampanhas" :key="'selo-camp' + index">
                  <a :href="`${$SiteUrl}/loja/campanhas/${campanha.url}`" style="padding-right: 15px">
                    <img v-bind:src="campanha.selo" width="70" />
                  </a>
                </span>
              </div>
              <div class="row" style="margin-top: -10px"></div>
              <div
                v-if="productDetails.IsGerador && this.isLogged && customTypes.some((value) => productDetails.Segmento.includes(value))"
                style="display: flex; gap: 10px; margin-top: 10px"
              >
                <button class="btn btn-primary" type="button" @click="personalizarGerador" style="flex: 1; border-radius: 6px;">
                  <i class="fa fa-cog" style="margin-right: 4px"></i> Personalize este Gerador
                </button>

                <button type="button" class="btn btn-warning" @click="gerarProposta" style="flex: 1; border-radius: 6px;">
                  <i v-if="!loading" class="fa fa-file"></i>
                  <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                  Gerar proposta
                </button>
              </div>

              
                  <BuyButton v-if="this.productDetails.Preco != 0" :product="product" />
               

              <div class="product-short-desc" style="border-radius: 4px;">
                <p>
                  <span>Múltiplo:</span>
                  {{ `${productDetails.PRD_QTDEUNID} ${productDetails.UND_DESCRICAO}(s)` }}
                </p>
              </div>
            </div>

            <div v-if="loadingProdutosCompreTambem">
              <ProductsWithBanner
                section="Quem comprou, comprou também"
                :products="relatedProducts"
                v-if="relatedProducts.length > 0"
                id="produtos-relacionados"
                style="width: 100%"
                responsive='{"0":{"items":"1"},"480":{"items":"2"},"768":{"items":"3"},"992":{"items":"4"},"1200":{"items":"4"}}'
              />
            </div>

            <div class="advance-info">
              <div v-if="productDetails.IsGerador && this.isLogged">
                <div class="div-condicoes-comerciais alert alert-secondary">
                  <strong>IMOBILIZADO/CONSUMO:</strong> Compra exclusiva para ativo imobilizado / consumo próprio. Proibida a revenda de itens
                  comprados como ativo imobilizado / consumo.
                </div>
                <div class="div-condicoes-comerciais alert alert-danger">
                  <strong>VENDA DIRETA:</strong> Intermediação de venda a consumidor final, com comissão para a revenda. Desconta-se da comissão os
                  impostos, frete, juros e taxa bancária. Para fazer vendas diretas, é necessário assinar o
                  <a href="https://www.aldo.com.br/portais/venda-direta/" target="_blank"> Acordo Comercial de Revendas ALDO </a>
                </div>
              </div>

              <div class="tab-control normal">
                <a v-if="productDetails.DescricaoTecnica" href="#description" class="tab-control-item">
                  Descrição Técnica
                  <i class="fa fa-plus"></i>
                </a>
                <a href="#warranty" class="tab-control-item">Procedimentos para Garantia <i class="fa fa-plus"></i> </a>
                <a v-if="productDetails.Folhetos.length > 0" href="#folhetos" class="tab-control-item">Folhetos <i class="fa fa-plus"></i> </a>
              </div>
              <div v-if="productDetails" class="tab-contents">
                <!-- Descrição técnica -->
                <div v-if="productDetails.DescricaoTecnica" class="tab-content-item" id="description" v-html="productDetails.DescricaoTecnica"></div>

                <!-- Garantia -->
                <div v-if="productDetails.Garantia" id="warranty" class="tab-content-item" v-html="productDetails.Garantia"></div>

                <!-- Folhetos -->
                <div v-if="productDetails.Folhetos.length > 0" id="folhetos" class="tab-content-item">
                  <ul class="folhetos">
                    <li v-for="(brochure, index) in productDetails.Folhetos" :key="index">
                      <a :href="brochure.Url" :title="brochure.Descricao" rel="nofollow" target="_blank">
                        {{ brochure.Descricao }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-regra-aviso" class="modal modal-dialog-centered" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <img id="img-aviso" class="d-block w-100" src="" alt="Aviso" style="width: 100%" />
          </div>
          <div class="modal-footer">
            <button v-on:click="closeModalAvisos()" class="btn btn-primary">FECHAR</button>
          </div>
        </div>
      </div>
    </div>

    <div id="myModalCartaoCredito" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-center"><strong>Meios de pagamento para este produto</strong></h4>
          </div>
          <div class="modal-body">
            <iframe
              class="ui-pdp-iframe"
              title="Ver meios de pagamento e promoções"
              src="https://produto.mercadolivre.com.br/noindex/services/MLB2167040268/payments?new_version=true&amp;modal=true&amp;newIndex=true?controlled=true"
              frameborder="0"
              scrolling="no"
              style="height: 1761px; width: 100% !important"
            ></iframe>
          </div>
          <div class="modal-footer">
            <div class="col-md-3" style="float: right; padding: 0px">
              <button v-on:click="closeModalCartaoCredito()" class="btn btn-primary btn-block">FECHAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-promocao" class="modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-center">
              <strong> PROMOÇAO MÊS DA INDEPENDÊNCIA ENERGÉTICA - PAINEL 460W </strong>
            </h4>
          </div>
          <div class="modal-body">
            <img src="/assets/images/placa.jpg" alt="" style="cursor: pointer; width: 100%" @click="closeModalPromocaoAndRedirect()" />
          </div>
          <div class="modal-footer">
            <div class="col-md-3" style="float: right; padding: 0px">
              <button v-on:click="closeModalPromocao()" class="btn btn-primary btn-block">FECHAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogProposal" :style="{ zIndex: 1000, position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }">
      <ProposalGenerate
        :product="productProposal"
        :dialogProposal="dialogProposal"
        :transportadora="transportadora"
        @close="
          () => {
            dialogProposal = false
          }
        "
      >
      </ProposalGenerate>
    </div>

    <script v-html="this.schemaJSON" type="application/ld+json" v-if="productError == false"></script>
  </div>
</template>
<style type="text/css">
.shape {
  border-style: solid;
  border-width: 0 70px 40px 0;
  float: right;
  height: 0px;
  width: 0px;
  -ms-transform: rotate(360deg);
  /* IE 9 */
  -o-transform: rotate(360deg);
  /* Opera 10.5 */
  -webkit-transform: rotate(360deg);
  /* Safari and Chrome */
  transform: rotate(360deg);
}

.offer {
  background: #fff;
  border: 1px solid #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  margin: 15px 0;
  overflow: hidden;
}

.offer:hover {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: rotate scale(1.1);
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.shape {
  border-color: rgba(255, 255, 255, 0) #d9534f rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);
}

.offer-radius {
  border-radius: 7px;
}

.offer-danger {
  border-color: #d9534f;
}

.offer-danger .shape {
  border-color: transparent #d9534f transparent transparent;
}

.offer-success {
  border-color: #5cb85c;
}

.offer-success .shape {
  border-color: transparent #5cb85c transparent transparent;
}

.offer-default {
  border-color: #999999;
}

.offer-default .shape {
  border-color: transparent #999999 transparent transparent;
}

.offer-primary {
  border-color: #428bca;
}

.offer-primary .shape {
  border-color: transparent #428bca transparent transparent;
}

.offer-info {
  border-color: #5bc0de;
}

.offer-info .shape {
  border-color: transparent #5bc0de transparent transparent;
}

.offer-warning {
  border-color: #f0ad4e;
}

.offer-warning .shape {
  border-color: transparent #f0ad4e transparent transparent;
}

.shape-text {
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  position: relative;
  right: -40px;
  top: 2px;
  white-space: nowrap;
  -ms-transform: rotate(30deg);
  /* IE 9 */
  -o-transform: rotate(360deg);
  /* Opera 10.5 */
  -webkit-transform: rotate(30deg);
  /* Safari and Chrome */
  transform: rotate(30deg);
}

.offer-content {
  padding: 0 20px 10px;
}

@media (min-width: 487px) {
  .container {
    max-width: 750px;
  }

  .col-sm-6 {
    width: 50%;
  }
}

@media (min-width: 900px) {
  .container {
    max-width: 970px;
  }

  .col-md-4 {
    width: 33.33333333333333%;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1170px;
  }

  .col-lg-3 {
    width: 25%;
  }
}
</style>
<script>
import Breadcrumb from './partials/Breadcrumb.vue'
import Product from './partials/Product.vue'
import BuyButton from './partials/BuyButton.vue'
import ProductsWithBanner from './partials/homepage/ProductsWithBanner'
import axios from 'axios'
import SimulationSantander from './partials/santander/SimulationSantander.vue'
import SimulationSolagora from './partials/sol-agora/SimulationSolAgora.vue'
import SolAgoraService from '@/services/SolAgoraService'
import { convertNumberToReal } from '../Utils/formatNumber'
import ProductShippingDetails from './ProductShippingDetails'
import swal from 'sweetalert'
import ProposalGenerate from './partials/customization/ProposalGenerate.vue'
import PaymentOptionsModal from './PaymentOptionsModal.vue'

export default {
  name: 'ProductDetails',
  data() {
    return {
      showSimulationButton: false,
      showSimulationSantander: true,
      showSimulationSolAgora: false,
      productImages: {},
      productDetails: {},
      loadingProductDetails: true,
      productError: false,
      productSelo: [],
      relatedProducts: [],
      product: {},
      isLogged: false,
      loadingProdutosCompreTambem: false,
      productCampanhas: [],
      hasTimer: true,
      cliCodigo: 0,
      frete: {
        cep: '',
        totalProduto: 0,
        codigoProduto: 0,
        qtdeProduto: 0,
        codigoCliente: 0,
        valorRepasse: 0,
        isGerador: true,
        isBateria: false
      },
      qtdeProduto: 1,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      valorRepasseFormatado: '',
      codigoPainel: 0,
      maxPrecoSugerido: 0,
      dialogProposal: false,
      productProposal: null,
      loading: false,
      transportadora: null,
      customTypes: []
    }
  },
  components: {
    Breadcrumb,
    Product,
    ProductShippingDetails,
    BuyButton,
    SimulationSantander,
    SimulationSolagora,
    ProductsWithBanner,
    ProposalGenerate,
    PaymentOptionsModal
  },
  metaInfo() {
    const product = this.productDetails
    const _self = this
    let imagem = ''
    if (product.Imagens != undefined) {
      imagem = product.Imagens[0].ArqUrlNormal
    }

    return {
      title: `${product.Titulo}`,
      meta: [
        {
          name: 'description',
          content: `${product.PSG_DESCRICAO} ${product.PRD_DESCRICAO}`
        },
        {
          name: 'twitter:card',
          content: `${product.PSG_DESCRICAO} ${product.PRD_DESCRICAO}`
        },
        { name: 'twitter:title', content: `${product.Titulo}` },
        {
          name: 'twitter:description',
          content: `${product.PSG_DESCRICAO} ${product.PRD_DESCRICAO}`
        },
        // image must be an absolute path
        { name: 'twitter:image', content: imagem },
        // Facebook OpenGraph
        { property: 'og:title', content: `${product.Titulo}` },
        { property: 'og:site_name', content: 'Aldo Solar' },
        { property: 'og:locale', content: 'pt_BR' },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: imagem },
        {
          property: 'og:description',
          content: `${product.PSG_DESCRICAO} ${product.PRD_DESCRICAO}`
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: `${_self.$SiteUrl}${_self.$route.path.replace('/loja', '')}`
        }
      ]
    }
  },
  computed: {
    schemaJSON: function () {
      let images = []
      for (let index = 0; index < this.productImages.length; index++) {
        images.push(this.productImages[index].ArqUrlMiniatura)
      }
      let stock = 'http://schema.org/InStock'
      if (this.productDetails.Saldo == 'DISPONÍVEL' && this.productDetails.Preco > 0) {
        stock = 'http://schema.org/InStock'
      } else if (this.productDetails.Saldo == 'DISPONÍVEL' && this.productDetails.Preco == 0) {
        stock = 'http://schema.org/InStock'
      } else if (this.productDetails.Saldo == 'SOB ENCOMENDA' && this.productDetails.Preco > 0) {
        stock = 'http://schema.org/PreOrder'
      } else if (this.productDetails.Saldo == 'INDISPONÍVEL') {
        stock = 'http://schema.org/OutOfStock'
      }

      return {
        '@context': 'http://schema.org/',
        '@type': 'Product',
        name: `${this.productDetails.PSG_DESCRICAO} ${this.productDetails.PRD_DESCRICAO}`,
        image: images,
        description: this.productDetails.PRD_DESCRICAO,
        sku: this.productDetails.PRD_CODIGO,
        gtin13: this.productDetails.PRD_ABNT,
        mpn: this.productDetails.PRD_ABNT,
        brand: {
          '@type': 'Brand',
          name: this.productDetails.PGR_DESCRICAO
        },
        offers: {
          '@type': 'Offer',
          priceCurrency: 'BRL',
          price: this.productDetails.PrecoEUP,
          url: 'https://www.aldo.com.br' + this.$route.path,
          availability: stock,
          seller: {
            '@type': 'Organization',
            name: 'Aldo Solar'
          }
        }
      }
    },
    productImagesLink: function () {
      return this.productImages.length ? this.productImages.map((image) => image.ArqUrlNormal) : []
    },
    breadcrumbPages: function () {
      const description = this.productDetails.PSG_DESCRICAO || ''
      const productCode = this.productDetails.PRD_CODIGO ? `(${this.productDetails.PRD_CODIGO}-${this.productDetails.PRD_CODIGODV})` : ''
      const fullName = `${description} ${productCode}`
      return [
        { name: `Home`, link: 'https://www.aldo.com.br/loja' },
        {
          name: fullName
        }
      ]
    },
    precoPorPotencia: function () {
      return this.productDetails.IsGerador && this.productDetails.POTENCIA > 0 ? this.productDetails.Preco / (this.productDetails.POTENCIA * 1000) : 0
    },

    preco: function () {
      const price = this.convertToReal(this.productDetails.Preco)

      // Caso o valor seja 0 ou não exista, não exibe o preço
      return this.productDetails.Preco ? price : false
    },

    promotionalPrice: function () {
      const promotionalPrice = this.convertToReal(this.productDetails.PRECO_DE)
      return this.productDetails.PRECO_DE ? promotionalPrice : false
    },

    precoAvistaIgualPrecoAPrazo: function () {
      return this.productDetails.PrecoAVista == this.productDetails.Preco
    },

    produtoSemDesconto: function () {
      return this.productDetails.ProdutoSemDesconto
    },

    precoAVista: function () {
      var vlrPrice = this.productDetails.PrecoAVista
      if (vlrPrice !== undefined) {
        const price = this.convertToReal(this.productDetails.PrecoAVista)
        return this.productDetails.PrecoAVista > 0 ? price : false
      } else {
        return false
      }
    },
    precoConsumo: function () {
      const price = this.convertToReal(this.productDetails.PrecoConsumo_Imobilizado)
      return this.productDetails.PrecoConsumo_Imobilizado ? price : false
    },

    precoEUP: function () {
      const price = this.convertToReal(this.productDetails.PrecoEUP)
      return this.productDetails.PrecoEUP ? price : false
    },
    precoComSt: function () {
      const price = this.convertToReal(this.productDetails.PrecoComSt)
      return this.productDetails.PrecoComSt ? price : false
    },
    precoComStVista: function () {
      const price = this.convertToReal(this.productDetails.PrecoComStVista)
      return this.productDetails.PrecoComStVista ? price : false
    },
    precoMP: function () {
      const price = this.convertToReal(this.productDetails.precoMP)
      return this.productDetails.precoMP ? price : false
    },
    precoSTSimulacao: function () {
      const price = this.convertToReal(this.productDetails.PrecoSTSimulacao)
      return price
    },

    financiamentoStyles() {
      let count = 0
      count = this.showSimulationSantander ? count + 1 : count
      count = this.showSimulationSolAgora ? count + 1 : count

      count = count > 2 ? 2 : count

      return {
        display: 'grid',
        'grid-template-columns': `repeat(${count}, 1fr)`
      }
    }
  },
  mounted() {
    this.customTypes = ['ON GRID', 'HIBRIDO']

    $(document).on('click', '.tab-control.normal .tab-control-item', function (ev) {
      ev.preventDefault()
      var _this = $(this)
      if (!_this.hasClass('active')) {
        _this.siblings('.active').removeClass('active')
        _this.addClass('active')
        _this.parents().siblings('.tab-contents').find('.active').removeClass('active')
        _this.parents().siblings('.tab-contents').find(_this.attr('href')).addClass('active')
      }
    })
    const self = this
    $.ajax({
      url: this.$apiUrl + 'Session.svc/getsessions',
      dataType: 'json',
      type: 'GET',
      xhrFields: { withCredentials: true },
      success: async (data) => {
        if (data.DadosCliente != null) {
          self.isLogged = true
          this.cliCodigo = data.DadosCliente.CliCodigo
          self.getCronometroProduto()

          try {
            const res = await SolAgoraService.CheckIntegrator({
              apiUrl: this.$apiUrl,
              cnpj: data.DadosCliente.CliCiccgc
            })
            this.showSimulationSolAgora = res.data.Active
          } finally {
            this.showSimulationButton = true
          }
        }
      }
    })

    this.getProduct()
  },
  methods: {
    startTimer(timer) {
      const self = this

      jQuery('#timer-produto').each(function (index, el) {
        var _this = jQuery(this),
          _expire = timer
        _this.countdown(_expire, function (event) {
          jQuery(this).html(event.strftime('<span><b>%Dd</b></span> <span><b>%H:%M:%S</b></span>'))
        })
      })
    },
    getCronometroProduto() {
      const self = this
      const productCode = this.$route.params.code.split('-')[0]

      axios
        .get(self.$mktUrl + '/pagemotor.ASMX/getProdutoPeriodoPrecoDe?nrFilial=1&prd_cod=' + productCode)
        .then((response) => {
          let xml = new window.DOMParser().parseFromString(response.data, 'text/xml')
          let tags = xml.getElementsByTagName('anyType')[0].innerHTML
          let retorno = JSON.parse(tags)[0]
          if (retorno && retorno.DataFim) {
            let datahora = retorno.DataFim.split(' ')
            let data = datahora[0].split('/')
            let hora = datahora[1]
            var timer = data[2] + '/' + data[1] + '/' + data[0] + ' ' + hora
            self.hasTimer = true
            self.startTimer(timer)
          } else {
            self.hasTimer = false
          }
        })
        .catch((e) => {
          self.hasTimer = false
        })
    },
    getList() {
      this.$parent.getList()
    },
    convertToReal(number) {
      return convertNumberToReal(number)
    },

    getProduct() {
      const productCode = this.$route.params.code.split('-')[0]
      // this.getProductImages(productCode);
      this.getProductDetails(productCode)
      this.getProductSelo(productCode)
    },
    getProductSelo(idproduto) {
      var self = this
      var params = { codProduto: idproduto, Filial: 1 }
      const getselo = axios.post(this.$apiUrl + 'Marketing.svc/getcampanhasselos', params).then((response) => {
        if (response.data) {
          self.productSelo = response.data
        }
      })
    },
    getProductDetails(productCode) {
      const xhr = new XMLHttpRequest()

      // Busca o produto baseado
      xhr.open('get', this.$apiUrl + 'Produto.svc/getproduto/' + productCode)

      xhr.withCredentials = true

      xhr.send()

      xhr.onprogress = () => {
        this.loadingProductDetails = true
      }

      xhr.onreadystatechange = () => {
        if (xhr.status !== 200) this.productError = true
      }

      xhr.onload = () => {
        this.productDetails = JSON.parse(xhr.responseText)

        // Código provisório para campanha curta de frete grátis do painél 252186
        // Após a campanha, este código pode ser retirado
        const prod = this.productDetails.Folhetos.filter((f) => f.Tipo === 'PAINEL')[0] || this.productDetails.Folhetos[0]

        if (prod) this.codigoPainel = prod.Produto

        this.productImages = this.productDetails.Imagens
        this.productDetails.PSG_DESCRICAO = this.productDetails.Segmento

        this.product.id = this.productDetails.PRD_CODIGO
        this.product.code = this.productDetails.PRD_CODIGO + '-' + this.productDetails.PRD_CODIGODV
        this.product.name = this.productDetails.PSG_DESCRICAO + ' ' + this.productDetails.PGR_DESCRICAO
        this.product.state = 'PR'
        this.product.img = this.productDetails.PRD_CAMINHO
        this.product.description =
          this.productDetails.PRD_DESCRICAO.length < 50
            ? this.productDetails.PRD_DESCRICAO
            : this.productDetails.PRD_DESCRICAO.substring(0, 49) + '...'

        const productDesc =
          this.product.name
            .replace(/\s+/g, '-')
            .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
            .toLowerCase() +
          '-' +
          this.productDetails.PRD_DESCRICAO.trim()
            .replace(/\s+/g, '-')
            .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
            .toLowerCase()

        this.product.url = '/loja/produto/' + this.product.code + '/' + productDesc
        this.product.price = this.productDetails.PRECOPRODUTO
        this.product.prdQtdeUnidade = this.productDetails.PRD_QTDEUNID
        this.qtdeProduto = this.productDetails.PRD_QTDEUNID
        this.product.showActions = false

        this.product.metaDescription = this.productDetails.DescricaoTecnica.substring(0, 170)
          .replace(/<[^>]*>/g, '')
          .replace(/<img.*$/gm, '')

        this.loadingProductDetails = false
        this.productDetails.CompreTambem.forEach((element) => {
          let product = {}
          product.id = element.PRD_CODIGO
          product.code = element.PRD_CODIGO + '-' + element.PRD_CODIGODV
          product.name = element.PSG_DESCRICAO + ' ' + element.PGR_DESCRICAO
          product.state = 'PR'
          product.img = element.PRD_CAMINHO
          product.description = element.PRD_DESCRICAO
          product.isLogged = element.IS_LOGGED

          const productDesc =
            product.name
              .replace(/\s+/g, '-')
              .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
              .toLowerCase() +
            '-' +
            element.PRD_DESCRICAO.trim()
              .replace(/\s+/g, '-')
              .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, '')
              .toLowerCase()

          product.url = '/loja/produto/' + product.code + '/' + productDesc
          product.price = element.PRECOPRODUTO
          product.showActions = true
          this.relatedProducts.push(product)
          this.loadingProdutosCompreTambem = true
        })

        setTimeout(() => this.startSlider(), 300)

        let precoProduto = this.precoEUP || this.preco
        if (precoProduto) {
          precoProduto = precoProduto.replace('R$ ', '').replace(',', '.')
          precoProduto = parseFloat(precoProduto)
        }

        this.maxPrecoSugerido = this.productDetails.PrecoEUP - this.productDetails.Preco

        let session = JSON.parse(localStorage.getItem('usuarioLogado'))
        let codigoUltimoAcesso = session != null ? session.DadosCliente.IdUltimoAcesso : ''

        // Google tag Manager - gtm.js
        this.$gtm.push({
          event: 'view_item',
          id: this.product.code,
          name: this.product.name,
          price: precoProduto,
          timestamp: new Date().getTime(),
          pageType: 'ProductPage',
          idUltimoAcesso: codigoUltimoAcesso
        })

        if (this.productDetails.IsGerador && this.productDetails.PainelPromocao) {
          setTimeout(() => $('#modal-promocao').modal('show'), 500)
        }

        this.validarRegraAvisos(this.preco)

        this.carregaDataLayer(this.productDetails)
      }
    },

    closeModalPromocaoAndRedirect: function () {
      this.closeModalPromocao()

      window.location = '/loja/campanhas/mes-independencia-energetica'
    },
    openCotacaoFrete: function (fromValorRepasse = false) {
      let valorRepasse = parseFloat(this.valorRepasseFormatado.toString().replace('R$', '').replaceAll('.', '').replace(',', '.'))

      if (!fromValorRepasse || this.frete.valorRepasse !== valorRepasse) {
        if (valorRepasse > this.maxPrecoSugerido) {
          swal({
            title: 'Aviso',
            text: 'Valor do Repasse não pode ser maior que o Máximo sugerido de: ' + this.formatCurrency(this.maxPrecoSugerido),
            icon: 'warning'
          })
          this.valorRepasseFormatado = this.formatCurrency(this.maxPrecoSugerido)
          valorRepasse = this.maxPrecoSugerido
        }

        if (this.frete.cep.length === 9) {
          this.frete.codigoProduto = this.productDetails.PRD_CODIGO
          this.frete.qtdeProduto = Number(this.qtdeProduto)
          this.frete.codigoCliente = this.cliCodigo
          this.frete.totalProduto = parseFloat(this.precoAVista.toString().replace('R$ ', '').replaceAll('.', '').replace(',', '.'))
          this.frete.valorRepasse = valorRepasse
          this.frete.peso = this.productDetails.PRD_PESO * this.frete.qtdeProduto
          this.frete.isGerador = this.productDetails.IsGerador
          $('#product-shipping-details-modal').modal('show')
          setTimeout(() => this.$refs.modalFrete.calculaFrete(this.codigoPainel, true), 300)
        }
      }
    },
    personalizarGerador: function () {
      const personalizacaoExistente = JSON.parse(localStorage.getItem('geradoresPeronalizados'))

      if (!personalizacaoExistente || personalizacaoExistente.length === 0) {
        window.location = `/loja/personalizacao-gerador?prod=${this.productDetails.PRD_CODIGO}`
        return
      }

      swal({
        title: 'Personalização de gerador',
        text: 'Já existe uma personalização em andamento e ela será descartada.\n\nDeseja realmente continuar?',
        buttons: ['Não', 'Sim'],
        dangerMode: true
      }).then((novo) => {
        if (novo) {
          window.location = `/loja/personalizacao-gerador?prod=${this.productDetails.PRD_CODIGO}`
        }
      })
    },

    closeModalCartaoCredito: function () {
      $('#myModalCartaoCredito').modal('hide')
    },

    closeModalPromocao: function () {
      $('#modal-promocao').modal('hide')

      axios.post(`${this.$apiUrl}Produto.svc/GravarVisualizouPromocao`, {
        cliCodigo: this.cliCodigo
      })
    },
    startSlider: function () {
      if ($('.product-gallery').length > 0) {
        $('.product-gallery').flexslider({
          animation: 'slide',
          pauseOnHover: true,
          controlNav: 'thumbnails'
        })

        var config = {
          margin: 10,
          nav: true,
          dots: false,
          autoplayHoverPause: true,
          dots: false,
          loop: false,
          navText: ['<i class="fa fa-angle-left " aria-hidden="true"></i>', '<i class="fa fa-angle-right " aria-hidden="true"></i>']
        }
        config.responsive = {
          0: { items: '2' },
          370: { items: '3' },
          480: { items: '4' },
          768: { items: '4' },
          992: { items: '3' },
          1200: { items: '4' }
        }
        $('.flex-control-thumbs').owlCarousel(config)
      }
    },
    mostrarModal() {
      $('#simulation-santander').modal('show')
    },
    mostrarModalSolAgora() {
      $('#simulation-solagora').modal('show')
    },
    async validarRegraAvisos(preco) {
      preco = parseFloat(preco.toString().replace('R$ ', '').replace('.', ''))
      const regrasAvisos = JSON.parse(localStorage.getItem('regrasAvisos'))

      const filters = {
        0: (preco, valor, frequencia) => preco === valor && frequencia > 0,
        1: (preco, valor, frequencia) => preco > valor && frequencia > 0,
        2: (preco, valor, frequencia) => preco < valor && frequencia > 0
      }

      if (!regrasAvisos) return

      const regrasEncontradas = regrasAvisos.filter((f) => {
        const regraSatisfeita = filters[f.Operador](parseFloat(preco), parseFloat(f.Valor), f.Frequencia)

        return regraSatisfeita
      })

      if (regrasEncontradas.length > 0) {
        const { data } = await axios.get(this.$apiUrl + '/Marketing.svc/get-url-imagem-aviso/' + regrasEncontradas[0].Codigo)

        $('#img-aviso').attr('src', data)
        $('#modal-regra-aviso').modal('show')

        const regrasComFrequenciaAtualizada = regrasAvisos.map((f) => {
          if (f.Codigo === regrasEncontradas[0].Codigo) f.Frequencia -= 1
          return f
        })

        localStorage.setItem('regrasAvisos', JSON.stringify(regrasComFrequenciaAtualizada))

        await axios.post(
          this.$apiUrl + '/Marketing.svc/insert-log-visualizacao-aviso',
          {
            codigoRegraAviso: regrasEncontradas[0].Codigo,
            produto: this.product.code.split('-')[0],
            preco: preco
          },
          { withCredentials: true }
        )
      }
    },
    closeModalAvisos() {
      $('#modal-regra-aviso').modal('hide')
    },
    bloquearBotaoBuscaFrete(e) {
      const bloquear = this.frete.cep.length != 8
      return bloquear
    },

    formatCurrency: function (v) {
      //formada coluna de valores da tabela para moeda
      const formato = {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL'
      }

      return parseFloat(v).toLocaleString('pt-BR', formato)
    },

    updateQty: function (qty) {
      this.qtdeProduto = parseInt(qty)
      this.openCotacaoFrete(false)
    },
    carregaDataLayer(value) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'view_item',
          ecommerce: {
            items: [
              {
                item_name: value.PRD_DESCRICAO,
                item_id: `${value.PRD_CODIGO}-${value.PRD_CODIGODV}`,
                price: value.Preco,
                item_brand: value.PSG_DESCRICAO,
                quantity: 1
              }
            ]
          }
        })
      }
    },
    async gerarProposta() {
      this.productProposal = { Codigo: this.productDetails.PRD_CODIGO.toString() }
      this.dialogProposal = true
      this.loading = true
    }
  }
}
</script>
